// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notificationspanel-inline-1 {
  font-size: 12px;
  color: var(--primary);
  font-weight: 600;
  cursor: pointer;
}

.notificationspanel-inline-2 {
  cursor: pointer;
}

.notificationspanel-inline-3 {
  flex: 1 1;
}

.notificationspanel-dyn-1 {
  text-align: center;
  padding: 20px;
  color: var(--notificationspanel-1-color);
  font-size: 13px;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/Intern/NotificationsPanel.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,wCAAwC;EACxC,eAAe;AACjB","sourcesContent":[".notificationspanel-inline-1 {\n  font-size: 12px;\n  color: var(--primary);\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.notificationspanel-inline-2 {\n  cursor: pointer;\n}\n\n.notificationspanel-inline-3 {\n  flex: 1;\n}\n\n.notificationspanel-dyn-1 {\n  text-align: center;\n  padding: 20px;\n  color: var(--notificationspanel-1-color);\n  font-size: 13px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
